export const ADMIN_RIGHTS = {
    SUPER: 'RW+',
    ALL: 'RW',
    READ: 'R',
    NONE: 'N'
}

export const IDPROOF_TYPES = [
    { name: "PAN", value: "PAN" },
    { name: "Aadhaar", value: "AADHAAR" },
    { name: "Driving License", value: "DL" },
]

export const TXN_STATUSES = [
    { label: 'Approved', value: 'APPROVED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Rejected', value: 'REJECTED' },
]

export const SCHEME_STATUSES = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' },
    { label: 'Deleted', value: 'DELETED' },
]

export const REWARD_STATUSES = [
    { label: 'Pending', value: 'PENDING' },
    { label: 'Claimed', value: 'CLAIMED' },
    { label: 'Processed', value: 'PROCESSED' },
    { label: 'Completed', value: 'COMPLETED' },
]

export const ROLES = [
    { name: "Super Admin", code: "SUPER_ADMIN" },
    { name: "Admin", code: "ADMIN" },
    { name: "Executive", code: "EXECUTIVE" },
    { name: "TSI", code: "TSI" },
]

export const FLOORS = ["G", "G+1", "G+2", "G+3", "G+4", "G+5", "Other"]

export const ROLE_CODES = {
    SUPER_ADMIN: "SUPER_ADMIN",
    ADMIN: "ADMIN",
    EXECUTIVE: "EXECUTIVE",
    TSI: "TSI",
}

export const MOVEMENT_TYPES = [
    { label: 'Inward', value: 'INWARD' },
    { label: 'Outward', value: 'OUTWARD' },
]

export const MARKETING_REMARKS = [
    { label: 'Continue', value: 'CONTINUE' },
    { label: 'Discontinue', value: 'DISCONTINUE' },
]

export const MARKETING_STATUS = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive/closed', value: 'INACTIVE' },
    { label: 'Renewal Pending', value: 'RENEWALPENDING' },
]

export const MARKETING_STATUSES_FILTER = [...MARKETING_STATUS, { label: 'Deleted', value: 'DELETED' }]

export const BRANDS = [
    { label: 'Sunvik Gold', value: 'SUNVIKGOLD', backgroundColor: '#FF3801', color: 'white' },
    { label: 'Om Sai', value: 'OMSAI', backgroundColor: '#6C2E86', color: 'white' },
    { label: 'Wirepro', value: 'WIREPRO', backgroundColor: '#3DA643', color: 'white' },
]

export const INDIAN_STATES = [
    { label: 'Andhra Pradesh', value: 'Andhra Pradesh' },
    { label: 'Arunachal Pradesh', value: 'Arunachal Pradesh' },
    { label: 'Assam', value: 'Assam' },
    { label: 'Bihar', value: 'Bihar' },
    { label: 'Chhattisgarh', value: 'Chhattisgarh' },
    { label: 'Goa', value: 'Goa' },
    { label: 'Gujarat', value: 'Gujarat' },
    { label: 'Haryana', value: 'Haryana' },
    { label: 'Himachal Pradesh', value: 'Himachal Pradesh' },
    { label: 'Jharkhand', value: 'Jharkhand' },
    { label: 'Karnataka', value: 'Karnataka' },
    { label: 'Kerala', value: 'Kerala' },
    { label: 'Madhya Pradesh', value: 'Madhya Pradesh' },
    { label: 'Maharashtra', value: 'Maharashtra' },
    { label: 'Manipur', value: 'Manipur' },
    { label: 'Meghalaya', value: 'Meghalaya' },
    { label: 'Mizoram', value: 'Mizoram' },
    { label: 'Nagaland', value: 'Nagaland' },
    { label: 'Odisha', value: 'Odisha' },
    { label: 'Punjab', value: 'Punjab' },
    { label: 'Rajasthan', value: 'Rajasthan' },
    { label: 'Sikkim', value: 'Sikkim' },
    { label: 'Tamil Nadu', value: 'Tamil Nadu' },
    { label: 'Telangana', value: 'Telangana' },
    { label: 'Tripura', value: 'Tripura' },
    { label: 'Uttar Pradesh', value: 'Uttar Pradesh' },
    { label: 'Uttarakhand', value: 'Uttarakhand' },
    { label: 'West Bengal', value: 'West Bengal' }
];

export const format = "YYYY-MM-DD HH:mm:ss";
export const format_only_date = "DD-MM-YYYY";
export const format_export = "DD-MM-YYYY HH:mm:ss";
export const format_fancy = "Do MMM YYYY HH:mm:ss";
export const format_display_withtime = "Do MMM YYYY HH:mm:ss a";
export const format_without_time = "YYYY-MM-DD";
export const format_display = "DD/MM/YYYY";
// export const format_export = "DD/MM/YY";
export const format_display_date = "Do MMM YYYY HH:mm";
export const format_display_fancy_notime = "Do MMM YYYY";
export const format_display_fancy = "Do MMM YYYY hh:mm a";
export const format_display_fancy_my = "MMM YYYY";
export const format_display_fancy_notime_withDay = "dddd, Do MMM";
export const format_display_fancy_notime_withDayAndyear = "dddd, Do MMM YYYY";
export const format_display_fancy_notime_withMonthAndyear = "MMM YYYY";

export const MAP_API_KEY = "AIzaSyDT8lKGV1ux38K0M__SaDJaVX8EfHPNv9k"